import React, { useEffect, useRef, useState } from "react";
import {
  BLOCK_ICON,
  CHECK_ICON,
  DELETE_ICON,
  LOCATION_ICON,
  NOAVAILABILITYADDED,
  PROFILE_IMG,
} from "../../utils/aap-image-constant";
import TableLayout from "../../components/layouts/table-layout";
import TableHeading from "../../components/common/TableHeading";
import Modal from "../../components/common/Model";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../hooks/routes/routes-constant";
import Calendar from "react-calendar/dist/cjs/Calendar.js";
import Button from "../../components/common/button";
import { useTranslation } from "react-i18next";
import {
  decryptAEStoJSON,
  EllipsisWithTooltip,
  LoaderSpinner,
  toastEmitter,
} from "../../utils/utilities";
import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
import { lowerCase } from "lodash";
import {
  availabiltySlotListDoctorWise,
  deleteAvailability,
  doctorListforAvailability,
  getExpertiesById,
  updateDoctorAvailability,
} from "../../hooks/services/api-services";
import { useSelector } from "react-redux";
import { convertTimeToAmPm, handleDateFormate, handleFormInput, localToUtcTime, utcToLocalDayjs, utcToLocalTime } from "../../utils/form-utils";
import { TimePicker } from "antd";
import dayjs from "dayjs";
import Input from "../../components/common/input";
import AccessPermissionpage from "../../components/common/accessPermissionpage";
import { API_URL } from "../../utils/url-constants";
const AvailabilityManagement = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [slotActionError, setSlotActionError] = useState("");
  const location = useLocation();
  const addbuttonClick = useRef();
  const isFirstRender = useRef(true);
  const [pending, setPending] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [rowData, setRowData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const [onlineDeleteLoading, setOnlineDeleteLoading] = useState(false);
  const [offlineDeleteLoading, setOfflineDeleteLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [doctorData, setDoctorData] = useState(null);
  const { value } = useSelector((state) => state?.loggedUser);
  const [onlineSlotError, setOnlineSlotError] = useState("");
  const [offlineSlotError, setOfflineSlotError] = useState("");
  const userData = decryptAEStoJSON(value);
  const payload = {
    pageIndex: page || 0,
    pageSize: pageSize || DEFAULT_PAGE_LENGTH,
    status: null,
    country: userData?.country,
    clinicId: userData?.id,
    searchText: searchTerm,
    direction: sortDirection || "desc",
    filterByFieldName: sortColumn || "id",
    bothDoctors: false,
    type: "",
    languageType: i18n.language,
  };
  const [selectedDate, setSelectedDate] = useState(new Date());
  const formateDate = handleDateFormate(selectedDate);
  const today = new Date();
  const [allAvailableSlot, setAllAvailableSlot] = useState([]);
  const [isBlock, setIsBlock] = useState([]);
  const [offlineSlot, setOfflineSlot] = useState([]);
  const [onlineSlot, setOnlineSlot] = useState([]);
  const [viewDoctorSlotPayload, setViewDoctorSlotPayload] = useState({
    clinicId: userData?.id,
    doctorId: 0,
    date: formateDate,
    languageType: i18n.language,
    expertise: ""
  });

  useEffect(() => {
    setViewDoctorSlotPayload((prev) => ({
      ...prev,
      doctorId: doctorData?.id,
      date: formateDate,
      languageType: i18n.language,
    }));
  }, [doctorData, formateDate, i18n.language]);

  const tableColumns = [
    {
      code: "S.No",
      name: t("S.No"),
      width: "100px",
      omit: false,
      selector: (row, index) => `${page * pageSize + index + 1}`,
    },
    {
      name: t("Doctor Name"),
      code: "first_name",
      width: "230px",
      selector: (row) => row?.d_name,
      sortable: true,
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center fs-12 fw-600">
          <div className="rounded-circle overflow-hidden rounded-circle">
            <img
              src={
                row?.image ? `${API_URL?.ServerURL}${row?.image}` : PROFILE_IMG
              }
              alt=""
              style={{
                objectFit: "cover",
                objectPosition: "center",
                width: "32px",
                height: "32px",
              }}
            />
          </div>
          {`${row?.firstName}  ${row?.lastName}`}
        </div>
      ),
    },
    {
      name: t("E-mail"),
      width: "200px",
      selector: (row) => (
        <EllipsisWithTooltip
          text={`${row?.email || "N/A"}`}
          maxWidth="250px"
        />
      ),
    },
    {
      name: t("Mobile Number"),
      cell: (row) => {
        return <>{`${row?.code} ${row?.mobileNo}`}</>;
      },
    },

    {
      name: t("Check Availability"),
      width: "180px",
      selector: (row) => row?.Checkvailability,
      cell: (row) => (
        <button
          className={`unset-property ${permissionAccess?.addAction !== 1 ? "disabled-style" : ""
            }`}
          onClick={() =>
            permissionAccess?.addAction === 1 && addButtonClick(row)
          }
          disabled={permissionAccess?.addAction !== 1}
        >
          <img src={CHECK_ICON} alt="Doctor Detail" />
        </button>
      ),
    },
    {
      name: t("Block Availability"),
      width: "180px",
      selector: (row) => row?.BlockAvailability,
      cell: (row) => (
        <button
          className={`unset-property ${permissionAccess?.addAction !== 1 ? "disabled-style" : ""
            }`}
          onClick={() =>
            permissionAccess?.addAction === 1 && blockAvailabilityClick(row)
          }
          disabled={permissionAccess?.addAction !== 1}
        >
          <img src={BLOCK_ICON} alt="" />
        </button>
      ),
    },
  ];

  // route to the add and block availability page
  // const addAvailabilityClick = () => {
  //   if (addbuttonClick?.current) {
  //     addbuttonClick?.current?.click(); // Close the modal
  //   }
  //   const clinicId = userData?.id;
  //   const doctorId = doctorData?.id;
  //   const doctorDetails = doctorData;
  //   const selectedDataAvlbty = formateDate;
  //   navigate(
  //     `${ROUTES.AVAILABILITY}/addAvailability/Dr.${lowerCase(
  //       doctorData?.firstName
  //     )}-${lowerCase(doctorData?.lastName)}`,
  //     { state: { clinicId, doctorId, doctorDetails, selectedDataAvlbty } }
  //   ); // Navigate after closing modal
  // };
  const addAvailabilityClick = () => {
    const doctorId = doctorData?.id;
    const isQuestionAdded =
      Number(doctorData?.isQuestionAdded) === 1;

    // If questions not added
    if (!isQuestionAdded) {
      // Close modal first
      if (addbuttonClick?.current) {
        addbuttonClick.current.click();
      }

      // Small delay so modal fully closes
      setTimeout(() => {
        navigate(`/doctor/addquestion/${doctorId}/add`);
      }, 200);

      return;
    }

    // Normal flow
    if (addbuttonClick?.current) {
      addbuttonClick.current.click();
    }

    const clinicId = userData?.id;
    const doctorDetails = doctorData;
    const selectedDataAvlbty = formateDate;

    setTimeout(() => {
      navigate(
        `${ROUTES.AVAILABILITY}/addAvailability/Dr.${lowerCase(
          doctorData?.firstName
        )}-${lowerCase(doctorData?.lastName)}`,
        { state: { clinicId, doctorId, doctorDetails, selectedDataAvlbty } }
      );
    }, 200);
  };

  const blockAvailabilityClick = (doctorData) => {
    const clinicId = userData?.id;
    const doctorId = doctorData?.id;
    const doctorDetails = doctorData;
    navigate(
      `${ROUTES.AVAILABILITY}/blockAvailability/Dr.${lowerCase(
        doctorData?.firstName
      )}-${lowerCase(doctorData?.lastName)}`,
      { state: { clinicId, doctorId, doctorDetails } }
    );
  };
  // show doctor list assosiast with clinic
  const fetchDoctorData = async () => {
    setPending(true);
    try {
      const response = await doctorListforAvailability(payload);
      if (response?.data?.status !== 200) {
        setRowData([]);
      } else {
        setRowData(response?.data?.data?.doctorResponseList);
        console.log("data", response?.data?.data?.doctorResponseList)
        setTotalRows(response?.data?.data?.totalElement);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    } finally {
      setPending(false);
      isFirstRender.current = false;
    }
  };
  useEffect(() => {
    fetchDoctorData();
  }, [page, pageSize, searchTerm, sortColumn, sortDirection, i18n.language]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  // get availability data slit wise
  const fetchAvailabilityData = async () => {
    setIsLoading(true);
    try {
      const response = await availabiltySlotListDoctorWise(
        viewDoctorSlotPayload
      );
      if (response?.data?.status !== 200) {
        // toastEmitter("error", response?.data?.message);
        setOfflineSlot([]);
        setOnlineSlot([]);
        setAllAvailableSlot([]);
        setIsBlock(response?.data?.data);
        setIsLoading(false);
      } else {
        setOfflineSlot(response?.data?.data?.offlineSlots);
        setOnlineSlot(response?.data?.data?.onlineSlots);
        setAllAvailableSlot(response?.data?.data);
        setIsBlock([]);
      }
    } catch (err) {
      if (isFirstRender.current) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      }
    } finally {
      setIsLoading(false);
      isFirstRender.current = false;
    }
  };

  useEffect(() => {
    if (viewDoctorSlotPayload?.doctorId) {
      fetchAvailabilityData();
    }
  }, [viewDoctorSlotPayload, i18n.language]);

  // update  and delete availability flow
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const [showUpdateSlot, setShowUpdateSlot] = useState(true);
  const [typeOfSlot, setTypeOfSlot] = useState("Online");
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [updateAvailabilityPayload, setUpdateAvailabilityPayload] = useState({
    clinicId: userData?.id,
    doctorId: doctorData?.id,
    timeSlotId: 0,
    date: formateDate,
    fromTime: "",
    toTime: "",
    type: typeOfSlot,
    location: typeOfSlot === "offline" ? userData?.address : "",
  });
  const [deleteAvailabilityPayload, setDeleteAvailabilityPayload] = useState({
    clinicId: userData?.id,
    doctorId: doctorData?.id,
    date: formateDate,
    slotList: [],
  });

  useEffect(() => {
    setUpdateAvailabilityPayload((prev) => ({
      ...prev,
      doctorId: doctorData?.id,
      clinicId: userData?.id,
      date: formateDate,
      type: typeOfSlot,
      location: typeOfSlot === "Offline" ? userData?.address : "",
    }));
    setDeleteAvailabilityPayload((prev) => ({
      ...prev,
      doctorId: doctorData?.id,
      clinicId: userData?.id,
      date: formateDate,
    }));
  }, [
    doctorData?.id,
    userData?.id,
    formateDate,
    typeOfSlot,
    userData?.address,
  ]);


  const handleSlotClick = (slotId, startTime, endTime, type) => {
    setTypeOfSlot(type);
    setSelectedSlotId((prev) => (prev === slotId ? null : slotId));

    // Clear slot action error based on slot type
    if (type === "Online") {
      setOnlineSlotError("");
    } else if (type === "Offline") {
      setOfflineSlotError("");
    }

    // Set update payload
    setUpdateAvailabilityPayload((prev) => ({
      ...prev,
      timeSlotId: slotId,
      fromTime: startTime,
      toTime: endTime,
    }));

    // Set delete payload
    setDeleteAvailabilityPayload((prev) => ({
      ...prev,
      slotList: [slotId],
    }));

    // Enable action buttons
    if (slotId) {
      setBtnDisabled(false);
    }
  };


  const handleUpdateCheck = () => {
    if (!selectedSlotId) {
      if (typeOfSlot === "Online") {
        setOnlineSlotError("Please select an online slot before editing.");
      } else {
        setOfflineSlotError("Please select an offline slot before editing.");
      }
      return;
    }

    // Clear errors if any
    setOnlineSlotError("");
    setOfflineSlotError("");

    // Hide the modal if slot is selected
    setShowUpdateSlot(false);
  };


  const handleFrom = (time) => {
    // const formattedTime = time ? dayjs(time).format("HH:mm") : "";
    const formattedTime = localToUtcTime(time);

    setUpdateAvailabilityPayload((prev) => ({
      ...prev,
      // fromTime: formattedTime,
      fromTime: localToUtcTime(time),
      toTime: "",
    }));
  };
  const handleTo = (time) => {
    // const formattedTime = time ? dayjs(time).format("HH:mm") : "";
    const formattedTime = localToUtcTime(time);

    setUpdateAvailabilityPayload((prev) => ({
      ...prev,
      // toTime: formattedTime,
      toTime: localToUtcTime(time),
    }));
  };

  const handleUpdateAvailability = async () => {
    if (updateAvailabilityPayload?.date?.trim() === "") {
      return toastEmitter("error", "Date is mandatory!");
    }
    if (updateAvailabilityPayload?.fromTime?.trim() === "") {
      return toastEmitter("error", "From Time is mandatory!");
    }
    if (updateAvailabilityPayload?.toTime?.trim() === "") {
      return toastEmitter("error", "To Time is mandatory!");
    }
    if (updateAvailabilityPayload?.timeSlotId === null) {
      return toastEmitter("error", "Please select the slot!");
    }
    setIsUpdateLoading(true);
    try {
      const response = await updateDoctorAvailability(
        updateAvailabilityPayload
      );
      if (response?.data?.status !== 200) {
        if (isFirstRender.current) {
          toastEmitter("error", response?.data?.message);
        }
      } else {
        toastEmitter("success", response?.data?.message);
        setUpdateAvailabilityPayload({
          clinicId: userData?.id,
          doctorId: doctorData?.id,
          timeSlotId: 0,
          date: "",
          fromTime: "",
          toTime: "",
          type: typeOfSlot,
          location: typeOfSlot === "offline" ? userData?.address : "",
        });
        setShowUpdateSlot(true);
        setSelectedSlotId(null);
        fetchAvailabilityData();
      }
    } catch (err) {
      if (isFirstRender.current) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      }
    } finally {
      setIsUpdateLoading(false);
      isFirstRender.current = false;
    }
  };


  const handleDeleteAvailability = async (type) => {
    if (!selectedSlotId) {
      if (type === "Online") {
        setOnlineSlotError("Please select an online slot before deleting.");
      } else {
        setOfflineSlotError("Please select an offline slot before deleting.");
      }
      return;
    }

    if (deleteAvailabilityPayload?.date?.trim() === "") {
      return toastEmitter("error", "Date is mandatory!");
    }

    if (deleteAvailabilityPayload?.slotList?.length === 0) {
      return toastEmitter("error", "Slot Id is mandatory!");
    }

    // Clear both errors before proceeding
    setOnlineSlotError("");
    setOfflineSlotError("");

    if (type === "Online") {
      setOnlineDeleteLoading(true);
    } else if (type === "Offline") {
      setOfflineDeleteLoading(true);
    }

    try {
      const response = await deleteAvailability(deleteAvailabilityPayload);

      if (response?.data?.status !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        toastEmitter("success", response?.data?.message);

        setDeleteAvailabilityPayload({
          clinicId: userData?.id,
          doctorId: doctorData?.id,
          slotList: [],
          date: formateDate,
        });

        setShowUpdateSlot(true);
        setSelectedSlotId(null);
        fetchAvailabilityData();
      }
    } catch (err) {
      if (isFirstRender.current) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      }
    } finally {
      setOnlineDeleteLoading(false);
      setOfflineDeleteLoading(false);
      isFirstRender.current = false;
    }
  };

  const addButtonClick = (row) => {
    setDoctorData(row);
    fetchAllExpertiesList(row.id);
    addbuttonClick?.current.click();
    setShowUpdateSlot(true);
    setBtnDisabled(true);
    setSelectedSlotId(null);
    setSelectedDate(new Date());
    setExpertiesData([]);
  };
  const handleDataBack = () => {
    setShowUpdateSlot(true);
    setBtnDisabled(true);
    setSelectedSlotId(null);
    setExpertiesData([]);
  };

  const handleCalenderPage = () => {
    navigate(`${ROUTES.AVAILABILITY}/slotCalander/view`); // Use a function reference here
  };

  // permission code for this module start
  const [permissionAccess, setPermissionAccess] = useState();
  const rawPermission = useSelector((state) => state?.permission?.value);
  const permissions = decryptAEStoJSON(rawPermission);
  useEffect(() => {
    const RoleAccessFilterData =
      permissions &&
      permissions?.filter((v) => v?.moduleName === "Availability Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, []);
  // permission code for this module end

  useEffect(() => {
    if (location?.state?.reopenAvailabilityModal) {
      addbuttonClick?.current.click();

      // Reopen Check Availability modal with passed data
      setShowUpdateSlot(true);

      setSelectedSlotId(null);
      setBtnDisabled(true);
      setSelectedDate(new Date(location.state?.selectedDate || Date.now()));
      setDoctorData(location.state?.doctorDetails);

      // Clean the navigation state so modal doesn't reopen on refresh
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location]);

  // get all experties in doctor
  const [expertiesData, setExpertiesData] = useState([])
  // const fetchAllExpertiesList = async () => {
  //   try {
  //     const response = await getExpertiesById(doctorData?.id, i18n.language);
  //     if (response?.data?.status !== 200) {
  //       // toastEmitter("error", response?.data?.message);
  //       setExpertiesData([]);
  //     }
  //     // else {
  //     //   setExpertiesData(response?.data?.data?.expertiseName);
  //     // }
  //     else {
  //       const list = response?.data?.data?.expertiseName || [];
  //       setExpertiesData(list);

  //       // AUTO SELECT FIRST EXPERTISE
  //       if (list.length > 0) {
  //         setViewDoctorSlotPayload((prev) => ({
  //           ...prev,
  //           expertise: list[0].expertiseName,
  //         }));
  //       }
  //     }
  //   } catch (err) {
  //     // toastEmitter("error", API_RESPONSE?.MESSAGE_503);
  //   }
  // };
  const fetchAllExpertiesList = async (doctorId) => {
    if (!doctorId) return;

    try {
      const response = await getExpertiesById(doctorId, i18n.language);

      if (response?.data?.status !== 200) {
        setExpertiesData([]);
      } else {
        const list = response?.data?.data?.expertiseName || [];
        setExpertiesData(list);

        // auto select first
        if (list.length > 0) {
          setViewDoctorSlotPayload((prev) => ({
            ...prev,
            expertise: list[0].expertiseName,
          }));
        }
      }
    } catch {
      setExpertiesData([]);
    }
  };
  useEffect(() => {
    if (!doctorData?.id) return;

    fetchAllExpertiesList(doctorData.id);
  }, [doctorData?.id, i18n.language]);


  // useEffect(() => {
  //   if (doctorData?.id) {
  //     fetchAllExpertiesList();
  //   }
  // }, [i18n.language, doctorData?.id]);
  return (
    <>
      {permissionAccess?.addAction === 0 &&
        permissionAccess?.updateAction === 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <>
          <div className="main_datatable my-lg-3 my-2">
            <TableHeading
              title={t("Availability Management")}
              searchValue={searchTerm}
              setSearchValue={setSearchTerm}
              showNormalbutton={permissionAccess?.viewAction === 1}
              ButtonClick={
                permissionAccess?.viewAction === 1
                  ? handleCalenderPage
                  : undefined
              }
              showbutton={false}
              data="Show All Availability"
            />

            <div className="table-wrapper">
              <TableLayout
                _tblColumns={tableColumns}
                _rowData={rowData}
                pending={pending}
                pagination={true}
                selectableRows={false}
                setPending={setPending}
                _totalRows={totalRows}
                pageSize={pageSize}
                setPageSize={setPageSize}
                setPage={setPage}
                setSortColumn={setSortColumn}
                setSortDirection={setSortDirection}
              />
            </div>
          </div>
          <Modal
            modalId="availabilityView"
            modalClick={addbuttonClick}
            className="modal-lg"
            // modalContentClass="pb-0"
            modalfooter="mt-2"
          >
            {showUpdateSlot ? (
              <div className="availabilityModel_content ">
                <div className="row ">
                  <div className="col-12 col-lg-5  mb-2">
                    <div className="dropdown-container mb-2">
                      {/* <select
                        className="form-select"
                        name="expertise"
                        value={viewDoctorSlotPayload?.expertise}
                        onChange={(e) => setViewDoctorSlotPayload(handleFormInput(e, viewDoctorSlotPayload))}
                      >
                        <option value="" className="font-primary">
                          Select Expertise
                        </option>
                        {expertiesData &&
                          [...expertiesData]
                            .sort((a, b) => a.expertiseName?.localeCompare(b.expertiseName))
                            .map((item, index) => (
                              <option key={index} value={item?.expertiseName}>
                                {item?.expertiseName}
                              </option>
                            ))}
                      </select> */}
                      <select
                        className="form-select"
                        name="expertise"
                        value={viewDoctorSlotPayload?.expertise}
                        onChange={(e) =>
                          setViewDoctorSlotPayload(
                            handleFormInput(e, viewDoctorSlotPayload)
                          )
                        }
                      >
                        {/* <option value="">Select Expertise</option> */}
                        {expertiesData.map((item, index) => (
                          <option key={index} value={item.expertiseName}>
                            {item.expertiseName}
                          </option>
                        ))}
                      </select>

                    </div>
                    <div className="addavailabiltymodel_left_content card border-0 h-100 mb-2" >
                      <Calendar
                        minDate={today}
                        onChange={handleDateChange}
                        locale={i18n.language}
                        value={selectedDate}
                      />
                    </div>


                  </div>
                  <div className="col-12 col-lg-7 mb-2">
                    <div className="addavailabiltymodel py-2 ">
                      <div className="d-flex flex-wrap justify-content-between px-2 py-2">
                        <h5>{t("Availability")}</h5>
                        <Button
                          label={t("Add Availability")}
                          className={` border-0 text-white py-1 px-3 rounded-3 ${isBlock?.isBlockedByDay ? "cancelbtn" : "submitbtn"
                            }`}
                          onClick={addAvailabilityClick}
                          isLoading={isBlock?.isBlockedByDay}
                          notShowLoading={true}
                        />
                      </div>
                      <hr className="mt-0 textcolor " />
                      {isLoading ? (
                        <LoaderSpinner />
                      ) : (
                        <div className="px-2">
                          {(allAvailableSlot &&
                            allAvailableSlot?.length !== 0) && (allAvailableSlot?.offlineSlots !== null || allAvailableSlot?.onlineSlots !== null) ? (
                            <>
                              {onlineSlot && onlineSlot?.length !== 0 && (
                                <div className="online_content mb-2  container p-2">
                                  <div className="row addavailability_content">
                                    <div className="col-12  d-flex justify-content-start align-items-center mb-2">
                                      <p className="textcolor btn btn-outline-textcolor rounded online_content px-2 py-0 ">
                                        {t("Online")}
                                      </p>
                                    </div>
                                    {onlineSlotError && (
                                      <p className="text-danger fs-12 text-start">
                                        {onlineSlotError}
                                      </p>
                                    )}

                                    <>
                                      {onlineSlot &&
                                        onlineSlot?.map((clinicSlot, idx) =>
                                          clinicSlot?.timeSlots?.map((slot) => {
                                            // Skip blocked slots
                                            // if (slot?.isBlockedByTime)
                                            //   return null;
                                            const isSelected =
                                              selectedSlotId === slot?.id;

                                            return (
                                              <div
                                                key={slot?.id}
                                                className={`col-12 col-lg-4 mb-2 cursor-pointer`}
                                                onClick={() => {
                                                  if (slot?.isBooked) {
                                                    toastEmitter(
                                                      "error",
                                                      "This slot is already booked and cannot be edited or deleted."
                                                    );
                                                    return;
                                                  }

                                                  if (slot?.isBlockedByTime) {
                                                    toastEmitter(
                                                      "error",
                                                      "This slot is blocked and cannot be edited or deleted."
                                                    );
                                                    return;
                                                  }

                                                  handleSlotClick(
                                                    slot?.id,
                                                    slot?.startTime,
                                                    slot?.endTime,
                                                    "Online"
                                                  );
                                                }}
                                              >
                                                <p
                                                  className={`rounded fs-12 mb-2 mb-md-0 py-2  fw-500 ${isSelected
                                                    ? "text-white buttonColor"
                                                    : slot?.isBooked
                                                      ? "color-green-bold bg-green-normal" : slot?.isBlockedByTime ? "bg-danger text-white"
                                                        : "buttonLightColor"
                                                    }`}
                                                >
                                                  {utcToLocalTime(
                                                    slot?.startTime
                                                  )}
                                                  -
                                                  {utcToLocalTime(
                                                    slot?.endTime
                                                  )}
                                                </p>
                                              </div>
                                            );
                                          })
                                        )}
                                    </>
                                  </div>
                                  <div className="row ">
                                    <div className="col-12 col-lg-4 pe-lg-0">
                                      <div
                                        className="text-align-center rounded  dangerColorLight mb-2 mb-md-0  p-1 cursor-pointer"
                                        onClick={() =>
                                          handleDeleteAvailability("Online")
                                        }
                                      >
                                        <button
                                          className="dangerColorLight rounded border-0 cursor-pointer "
                                          disabled={btnDisabled}
                                        >
                                          {onlineDeleteLoading && (
                                            <i className="fa fa-spinner fa-spin me-2"></i>
                                          )}
                                          <img
                                            src={DELETE_ICON}
                                            alt="delete"
                                            classNam
                                            e="img-fluid "
                                          />
                                        </button>
                                      </div>
                                    </div>

                                    <div className="col-12 col-lg-8 cursor-pointer">
                                      <button
                                        className="textcolor rounded buutonlightPrimeryColor mb-2 mb-md-0  p-1 border-0 w-100 cursor-pointer"
                                        onClick={handleUpdateCheck}
                                      >
                                        {t("Edit")}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {offlineSlot && offlineSlot?.length !== 0 && (
                                <div className="ofline_content container p-2">
                                  <div className="row addavailability_content">
                                    <div className="col-12  d-flex justify-content-start align-items-center mb-2">
                                      <p className="textcolor btn btn-outline-textcolor rounded online_content px-2 py-0 ">
                                        {t("Offline")}
                                      </p>
                                    </div>
                                    {offlineSlotError && (
                                      <p className="text-danger fs-12 text-start">
                                        {offlineSlotError}
                                      </p>
                                    )}
                                    {offlineSlot &&
                                      offlineSlot?.map((clinicSlot, idx) =>
                                        clinicSlot?.timeSlots?.map((slot) => {
                                          const isSelected = selectedSlotId === slot?.id; // assuming slot.id exists

                                          return (
                                            <div
                                              key={slot?.id}
                                              className={`col-12 col-lg-4 mb-2 cursor-pointer`}
                                              onClick={() => {
                                                if (slot?.isBooked) {
                                                  toastEmitter(
                                                    "error",
                                                    "This slot is already booked and cannot be edited or deleted."
                                                  );
                                                  return;
                                                }

                                                if (slot?.isBlockedByTime) {
                                                  toastEmitter(
                                                    "error",
                                                    "This slot is blocked and cannot be edited or deleted."
                                                  );
                                                  return;
                                                }

                                                handleSlotClick(
                                                  slot?.id,
                                                  slot?.startTime,
                                                  slot?.endTime,
                                                  "Offline"
                                                );
                                              }}
                                            >

                                              <p
                                                className={`rounded fs-12 mb-2 mb-md-0 py-2  fw-500 ${isSelected
                                                  ? "text-white buttonColor"
                                                  : slot?.isBooked
                                                    ? "color-green-bold bg-green-normal" : slot?.isBlockedByTime ? "bg-danger text-white"
                                                      : "buttonLightColor"
                                                  }`}
                                              >
                                                {utcToLocalTime(slot?.startTime)}
                                                -
                                                {utcToLocalTime(slot?.endTime)}
                                              </p>
                                            </div>
                                          );
                                        })
                                      )}

                                    <div className="col-12  d-flex justify-content-start mb-2">
                                      <div>
                                        {" "}
                                        <img src={LOCATION_ICON} alt="Icon" />
                                      </div>
                                      <p>{userData?.address}</p>
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-12 col-lg-4 pe-lg-0">
                                      <div
                                        className="text-align-center rounded  dangerColorLight mb-2 mb-md-0  p-1 cursor-pointer"
                                        onClick={() =>
                                          handleDeleteAvailability("Offline")
                                        }
                                      >
                                        <button
                                          className="dangerColorLight rounded border-0 cursor-pointer "
                                          disabled={btnDisabled}
                                        >
                                          {offlineDeleteLoading && (
                                            <i className="fa fa-spinner fa-spin me-2"></i>
                                          )}
                                          <img
                                            src={DELETE_ICON}
                                            alt="delete"
                                            classNam
                                            e="img-fluid "
                                          />
                                        </button>
                                      </div>
                                    </div>

                                    <div className="col-12 col-lg-8 cursor-pointer">
                                      <button
                                        className="textcolor rounded buutonlightPrimeryColor mb-2 mb-md-0  p-1 border-0 w-100 cursor-pointer"
                                        onClick={handleUpdateCheck}
                                      >
                                        Edit
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="">
                              <img
                                src={NOAVAILABILITYADDED}
                                alt="icon"
                                className="modelsuccessimg mb-2"
                              />
                              <h2
                                className={`tableheading fs-18 mb-2 fw-500 ${isBlock?.isBlockedByDay
                                  ? "text-danger"
                                  : "text-muted"
                                  }`}
                              >
                                {t(
                                  `${isBlock?.isBlockedByDay
                                    ? "Availability block for full day !"
                                    : t("Availability Not Added Yet !")
                                  } `
                                )}
                              </h2>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="availabilityModel_content ">
                  <div className="row ">
                    <div className="col-12 col-lg-5 mb-2">
                      <div className="addavailabiltymodel_left_content card border-0 h-100 ">
                        <Calendar
                          minDate={today}
                          onChange={handleDateChange}
                          value={selectedDate}
                        />
                      </div>

                    </div>
                    <div className="col-12 col-lg-7 mb-2">
                      <div className="addavailabiltymodel py-2 ">
                        <div className="d-flex flex-wrap justify-content-between px-2 py-2">
                          <h5>{t("Edit Availability")}</h5>
                        </div>
                        <hr className="mt-0 textcolor" />
                        <div className="px-2">
                          <div className="row">
                            <div className="col-12  d-flex justify-content-start mb-2">
                              <p className="textcolor btn btn-outline-textcolor rounded online_content px-2 py-0 ">
                                {t(typeOfSlot)}
                              </p>
                            </div>
                            <div className="col-6">
                              <TimePicker
                                // value={
                                //   updateAvailabilityPayload?.fromTime
                                //     ? dayjs(
                                //       updateAvailabilityPayload?.fromTime,
                                //       "HH:mm"
                                //     )
                                //     : null
                                // }
                                value={utcToLocalDayjs(updateAvailabilityPayload?.fromTime)}

                                className={"form-control"}
                                format="HH:mm"
                                placeholder="From"
                                onChange={(time) => handleFrom(time || "")}
                              />
                            </div>
                            <div className="col-6">
                              <TimePicker
                                // value={
                                //   updateAvailabilityPayload?.toTime
                                //     ? dayjs(
                                //       updateAvailabilityPayload?.toTime,
                                //       "HH:mm"
                                //     )
                                //     : null
                                // }
                                value={utcToLocalDayjs(updateAvailabilityPayload?.toTime)}

                                className={"form-control"}
                                format="HH:mm"
                                placeholder="To"
                                onChange={(time) => handleTo(time || "")}
                                disabled={!updateAvailabilityPayload?.fromTime}
                                disabledTime={() => {
                                  if (!updateAvailabilityPayload?.fromTime)
                                    return {};
                                  // const fromTime = dayjs(
                                  //   updateAvailabilityPayload?.fromTime,
                                  //   "HH:mm"
                                  // );
                                  const fromTime = utcToLocalDayjs(updateAvailabilityPayload?.fromTime);

                                  return {
                                    disabledHours: () => [
                                      ...Array(fromTime?.hour()).keys(),
                                    ],
                                    disabledMinutes: (h) =>
                                      h === fromTime.hour()
                                        ? [
                                          ...Array(
                                            fromTime.minute() + 15
                                          ).keys(),
                                        ]
                                        : [],
                                  };
                                }}
                              />
                            </div>
                            {typeOfSlot === "Offline" && (
                              <div className="col-12">
                                <Input
                                  className="border-radius_input py-2"
                                  type="text"
                                  value={userData?.address}
                                  name="location"
                                  disabled
                                  lableClassName="text-start d-flex justify-content-start"
                                  labelName="Location"
                                />
                              </div>
                            )}
                            <div className="col-12  cursor-pointer mt-2">
                              <div className="row">
                                <div className="col-4">
                                  <button
                                    type="button"
                                    className="p-1 rounded border-0 cancelbtn me-2  mb-2 mb-md-0 w-100 "
                                    onClick={handleDataBack}
                                  >
                                    {t("Cancel")}
                                  </button>
                                </div>
                                <div className="col-8">
                                  <button
                                    className="textcolor rounded buutonlightPrimeryColor mb-2 mb-md-0  p-1 border-0 w-100 fs-14"
                                    disabled={btnDisabled}
                                    onClick={handleUpdateAvailability}
                                    type="button"
                                  >
                                    {isUpdateLoading && (
                                      <i className="fa fa-spinner fa-spin me-2"></i>
                                    )}
                                    {t("Update")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </Modal>
        </>
      )}
    </>
  );
};

export default AvailabilityManagement;


// import React, { useEffect, useRef, useState } from "react";
// import {
//   BLOCK_ICON,
//   CHECK_ICON,
//   DELETE_ICON,
//   LOCATION_ICON,
//   NOAVAILABILITYADDED,
//   PROFILE_IMG,
// } from "../../utils/aap-image-constant";
// import TableLayout from "../../components/layouts/table-layout";
// import TableHeading from "../../components/common/TableHeading";
// import Modal from "../../components/common/Model";
// import { useLocation, useNavigate } from "react-router-dom";
// import { ROUTES } from "../../hooks/routes/routes-constant";
// import Calendar from "react-calendar/dist/cjs/Calendar.js";
// import Button from "../../components/common/button";
// import { useTranslation } from "react-i18next";
// import {
//   decryptAEStoJSON,
//   EllipsisWithTooltip,
//   LoaderSpinner,
//   toastEmitter,
// } from "../../utils/utilities";
// import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
// import { lowerCase } from "lodash";
// import {
//   availabiltySlotListDoctorWise,
//   deleteAvailability,
//   doctorListforAvailability,
//   getExpertiesById,
//   updateDoctorAvailability,
// } from "../../hooks/services/api-services";
// import { useSelector } from "react-redux";
// import { convertTimeToAmPm, handleDateFormate, handleFormInput } from "../../utils/form-utils";
// import { TimePicker } from "antd";
// import dayjs from "dayjs";
// import Input from "../../components/common/input";
// import AccessPermissionpage from "../../components/common/accessPermissionpage";
// import { API_URL } from "../../utils/url-constants";
// const AvailabilityManagement = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();
//   const [slotActionError, setSlotActionError] = useState("");
//   const location = useLocation();
//   const addbuttonClick = useRef();
//   const isFirstRender = useRef(true);
//   const [pending, setPending] = useState(false);
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
//   const [sortColumn, setSortColumn] = useState("");
//   const [sortDirection, setSortDirection] = useState("");
//   const [rowData, setRowData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [isUpdateLoading, setIsUpdateLoading] = useState(false);
//   const [onlineDeleteLoading, setOnlineDeleteLoading] = useState(false);
//   const [offlineDeleteLoading, setOfflineDeleteLoading] = useState(false);
//   const [totalRows, setTotalRows] = useState(0);
//   const [doctorData, setDoctorData] = useState(null);
//   const { value } = useSelector((state) => state?.loggedUser);
//   const [onlineSlotError, setOnlineSlotError] = useState("");
//   const [offlineSlotError, setOfflineSlotError] = useState("");
//   const userData = decryptAEStoJSON(value);
//   const payload = {
//     pageIndex: page || 0,
//     pageSize: pageSize || DEFAULT_PAGE_LENGTH,
//     status: null,
//     country: userData?.country,
//     clinicId: userData?.id,
//     searchText: searchTerm,
//     direction: sortDirection || "desc",
//     filterByFieldName: sortColumn || "id",
//     bothDoctors: false,
//     type: "",
//     languageType: i18n.language,
//   };
//   const [selectedDate, setSelectedDate] = useState(new Date());
//   const formateDate = handleDateFormate(selectedDate);
//   const today = new Date();
//   const [allAvailableSlot, setAllAvailableSlot] = useState([]);
//   const [isBlock, setIsBlock] = useState([]);
//   const [offlineSlot, setOfflineSlot] = useState([]);
//   const [onlineSlot, setOnlineSlot] = useState([]);
//   const [viewDoctorSlotPayload, setViewDoctorSlotPayload] = useState({
//     clinicId: userData?.id,
//     doctorId: 0,
//     date: formateDate,
//     languageType: i18n.language,
//     expertise: ""
//   });

//   useEffect(() => {
//     setViewDoctorSlotPayload((prev) => ({
//       ...prev,
//       doctorId: doctorData?.id,
//       date: formateDate,
//       languageType: i18n.language,
//     }));
//   }, [doctorData, formateDate, i18n.language]);

//   const tableColumns = [
//     {
//       code: "S.No",
//       name: t("S.No"),
//       width: "100px",
//       omit: false,
//       selector: (row, index) => `${page * pageSize + index + 1}`,
//     },
//     {
//       name: t("Doctor Name"),
//       code: "first_name",
//       width: "230px",
//       selector: (row) => row?.d_name,
//       sortable: true,
//       cell: (row) => (
//         <div className="d-flex gap-2 align-items-center fs-12 fw-600">
//           <div className="rounded-circle overflow-hidden rounded-circle">
//             <img
//               src={
//                 row?.image ? `${API_URL?.ServerURL}${row?.image}` : PROFILE_IMG
//               }
//               alt=""
//               style={{
//                 objectFit: "cover",
//                 objectPosition: "center",
//                 width: "32px",
//                 height: "32px",
//               }}
//             />
//           </div>
//           {`${row?.firstName}  ${row?.lastName}`}
//         </div>
//       ),
//     },
//     {
//       name: t("E-mail"),
//       width: "200px",
//       selector: (row) => (
//         <EllipsisWithTooltip
//           text={`${row?.email || "N/A"}`}
//           maxWidth="250px"
//         />
//       ),
//     },
//     {
//       name: t("Mobile Number"),
//       cell: (row) => {
//         return <>{`${row?.code} ${row?.mobileNo}`}</>;
//       },
//     },

//     {
//       name: t("Check Availability"),
//       width: "180px",
//       selector: (row) => row?.Checkvailability,
//       cell: (row) => (
//         <button
//           className={`unset-property ${permissionAccess?.addAction !== 1 ? "disabled-style" : ""
//             }`}
//           onClick={() =>
//             permissionAccess?.addAction === 1 && addButtonClick(row)
//           }
//           disabled={permissionAccess?.addAction !== 1}
//         >
//           <img src={CHECK_ICON} alt="Doctor Detail" />
//         </button>
//       ),
//     },
//     {
//       name: t("Block Availability"),
//       width: "180px",
//       selector: (row) => row?.BlockAvailability,
//       cell: (row) => (
//         <button
//           className={`unset-property ${permissionAccess?.addAction !== 1 ? "disabled-style" : ""
//             }`}
//           onClick={() =>
//             permissionAccess?.addAction === 1 && blockAvailabilityClick(row)
//           }
//           disabled={permissionAccess?.addAction !== 1}
//         >
//           <img src={BLOCK_ICON} alt="" />
//         </button>
//       ),
//     },
//   ];

//   // route to the add and block availability page
//   const addAvailabilityClick = () => {
//     if (addbuttonClick?.current) {
//       addbuttonClick?.current?.click(); // Close the modal
//     }
//     const clinicId = userData?.id;
//     const doctorId = doctorData?.id;
//     const doctorDetails = doctorData;
//     const selectedDataAvlbty = formateDate;
//     navigate(
//       `${ROUTES.AVAILABILITY}/addAvailability/Dr.${lowerCase(
//         doctorData?.firstName
//       )}-${lowerCase(doctorData?.lastName)}`,
//       { state: { clinicId, doctorId, doctorDetails, selectedDataAvlbty } }
//     ); // Navigate after closing modal
//   };
//   const blockAvailabilityClick = (doctorData) => {
//     const clinicId = userData?.id;
//     const doctorId = doctorData?.id;
//     const doctorDetails = doctorData;
//     navigate(
//       `${ROUTES.AVAILABILITY}/blockAvailability/Dr.${lowerCase(
//         doctorData?.firstName
//       )}-${lowerCase(doctorData?.lastName)}`,
//       { state: { clinicId, doctorId, doctorDetails } }
//     );
//   };

//   // show doctor list assosiast with clinic
//   const fetchDoctorData = async () => {
//     setPending(true);
//     try {
//       const response = await doctorListforAvailability(payload);
//       if (response?.data?.status !== 200) {
//         setRowData([]);
//       } else {
//         setRowData(response?.data?.data?.doctorResponseList);
//         setTotalRows(response?.data?.data?.totalElement);
//       }
//     } catch (err) {
//       toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//     } finally {
//       setPending(false);
//       isFirstRender.current = false;
//     }
//   };
//   useEffect(() => {
//     fetchDoctorData();
//   }, [page, pageSize, searchTerm, sortColumn, sortDirection, i18n.language]);

//   const handleDateChange = (date) => {
//     setSelectedDate(date);
//   };

//   // get availability data slit wise
//   const fetchAvailabilityData = async () => {
//     setIsLoading(true);
//     try {
//       const response = await availabiltySlotListDoctorWise(
//         viewDoctorSlotPayload
//       );
//       if (response?.data?.status !== 200) {
//         // toastEmitter("error", response?.data?.message);
//         setOfflineSlot([]);
//         setOnlineSlot([]);
//         setAllAvailableSlot([]);
//         setIsBlock(response?.data?.data);
//         setIsLoading(false);
//       } else {
//         setOfflineSlot(response?.data?.data?.offlineSlots);
//         setOnlineSlot(response?.data?.data?.onlineSlots);
//         setAllAvailableSlot(response?.data?.data);
//         setIsBlock([]);
//       }
//     } catch (err) {
//       if (isFirstRender.current) {
//         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//       }
//     } finally {
//       setIsLoading(false);
//       isFirstRender.current = false;
//     }
//   };

//   useEffect(() => {
//     if (viewDoctorSlotPayload?.doctorId) {
//       fetchAvailabilityData();
//     }
//   }, [viewDoctorSlotPayload, i18n.language]);

//   // update  and delete availability flow
//   const [selectedSlotId, setSelectedSlotId] = useState(null);
//   const [showUpdateSlot, setShowUpdateSlot] = useState(true);
//   const [typeOfSlot, setTypeOfSlot] = useState("Online");
//   const [btnDisabled, setBtnDisabled] = useState(true);
//   const [updateAvailabilityPayload, setUpdateAvailabilityPayload] = useState({
//     clinicId: userData?.id,
//     doctorId: doctorData?.id,
//     timeSlotId: 0,
//     date: formateDate,
//     fromTime: "",
//     toTime: "",
//     type: typeOfSlot,
//     location: typeOfSlot === "offline" ? userData?.address : "",
//   });
//   const [deleteAvailabilityPayload, setDeleteAvailabilityPayload] = useState({
//     clinicId: userData?.id,
//     doctorId: doctorData?.id,
//     date: formateDate,
//     slotList: [],
//   });

//   useEffect(() => {
//     setUpdateAvailabilityPayload((prev) => ({
//       ...prev,
//       doctorId: doctorData?.id,
//       clinicId: userData?.id,
//       date: formateDate,
//       type: typeOfSlot,
//       location: typeOfSlot === "Offline" ? userData?.address : "",
//     }));
//     setDeleteAvailabilityPayload((prev) => ({
//       ...prev,
//       doctorId: doctorData?.id,
//       clinicId: userData?.id,
//       date: formateDate,
//     }));
//   }, [
//     doctorData?.id,
//     userData?.id,
//     formateDate,
//     typeOfSlot,
//     userData?.address,
//   ]);


//   const handleSlotClick = (slotId, startTime, endTime, type) => {
//     setTypeOfSlot(type);
//     setSelectedSlotId((prev) => (prev === slotId ? null : slotId));

//     // Clear slot action error based on slot type
//     if (type === "Online") {
//       setOnlineSlotError("");
//     } else if (type === "Offline") {
//       setOfflineSlotError("");
//     }

//     // Set update payload
//     setUpdateAvailabilityPayload((prev) => ({
//       ...prev,
//       timeSlotId: slotId,
//       fromTime: startTime,
//       toTime: endTime,
//     }));

//     // Set delete payload
//     setDeleteAvailabilityPayload((prev) => ({
//       ...prev,
//       slotList: [slotId],
//     }));

//     // Enable action buttons
//     if (slotId) {
//       setBtnDisabled(false);
//     }
//   };


//   const handleUpdateCheck = () => {
//     if (!selectedSlotId) {
//       if (typeOfSlot === "Online") {
//         setOnlineSlotError("Please select an online slot before editing.");
//       } else {
//         setOfflineSlotError("Please select an offline slot before editing.");
//       }
//       return;
//     }

//     // Clear errors if any
//     setOnlineSlotError("");
//     setOfflineSlotError("");

//     // Hide the modal if slot is selected
//     setShowUpdateSlot(false);
//   };


//   const handleFrom = (time) => {
//     const formattedTime = time ? dayjs(time).format("HH:mm") : "";
//     setUpdateAvailabilityPayload((prev) => ({
//       ...prev,
//       fromTime: formattedTime,
//       toTime: "",
//     }));
//   };
//   const handleTo = (time) => {
//     const formattedTime = time ? dayjs(time).format("HH:mm") : "";
//     setUpdateAvailabilityPayload((prev) => ({
//       ...prev,
//       toTime: formattedTime,
//     }));
//   };

//   const handleUpdateAvailability = async () => {
//     if (updateAvailabilityPayload?.date?.trim() === "") {
//       return toastEmitter("error", "Date is mandatory!");
//     }
//     if (updateAvailabilityPayload?.fromTime?.trim() === "") {
//       return toastEmitter("error", "From Time is mandatory!");
//     }
//     if (updateAvailabilityPayload?.toTime?.trim() === "") {
//       return toastEmitter("error", "To Time is mandatory!");
//     }
//     if (updateAvailabilityPayload?.timeSlotId === null) {
//       return toastEmitter("error", "Please select the slot!");
//     }
//     setIsUpdateLoading(true);
//     try {
//       const response = await updateDoctorAvailability(
//         updateAvailabilityPayload
//       );
//       if (response?.data?.status !== 200) {
//         if (isFirstRender.current) {
//           toastEmitter("error", response?.data?.message);
//         }
//       } else {
//         toastEmitter("success", response?.data?.message);
//         setUpdateAvailabilityPayload({
//           clinicId: userData?.id,
//           doctorId: doctorData?.id,
//           timeSlotId: 0,
//           date: "",
//           fromTime: "",
//           toTime: "",
//           type: typeOfSlot,
//           location: typeOfSlot === "offline" ? userData?.address : "",
//         });
//         setShowUpdateSlot(true);
//         setSelectedSlotId(null);
//         fetchAvailabilityData();
//       }
//     } catch (err) {
//       if (isFirstRender.current) {
//         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//       }
//     } finally {
//       setIsUpdateLoading(false);
//       isFirstRender.current = false;
//     }
//   };


//   const handleDeleteAvailability = async (type) => {
//     if (!selectedSlotId) {
//       if (type === "Online") {
//         setOnlineSlotError("Please select an online slot before deleting.");
//       } else {
//         setOfflineSlotError("Please select an offline slot before deleting.");
//       }
//       return;
//     }

//     if (deleteAvailabilityPayload?.date?.trim() === "") {
//       return toastEmitter("error", "Date is mandatory!");
//     }

//     if (deleteAvailabilityPayload?.slotList?.length === 0) {
//       return toastEmitter("error", "Slot Id is mandatory!");
//     }

//     // Clear both errors before proceeding
//     setOnlineSlotError("");
//     setOfflineSlotError("");

//     if (type === "Online") {
//       setOnlineDeleteLoading(true);
//     } else if (type === "Offline") {
//       setOfflineDeleteLoading(true);
//     }

//     try {
//       const response = await deleteAvailability(deleteAvailabilityPayload);

//       if (response?.data?.status !== 200) {
//         toastEmitter("error", response?.data?.message);
//       } else {
//         toastEmitter("success", response?.data?.message);

//         setDeleteAvailabilityPayload({
//           clinicId: userData?.id,
//           doctorId: doctorData?.id,
//           slotList: [],
//           date: formateDate,
//         });

//         setShowUpdateSlot(true);
//         setSelectedSlotId(null);
//         fetchAvailabilityData();
//       }
//     } catch (err) {
//       if (isFirstRender.current) {
//         toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//       }
//     } finally {
//       setOnlineDeleteLoading(false);
//       setOfflineDeleteLoading(false);
//       isFirstRender.current = false;
//     }
//   };

//   const addButtonClick = (row) => {
//     setDoctorData(row);
//      fetchAllExpertiesList(row.id);
//     addbuttonClick?.current.click();
//     setShowUpdateSlot(true);
//     setBtnDisabled(true);
//     setSelectedSlotId(null);
//     setSelectedDate(new Date());
//     setExpertiesData([]);
//   };
//   const handleDataBack = () => {
//     setShowUpdateSlot(true);
//     setBtnDisabled(true);
//     setSelectedSlotId(null);
//     setExpertiesData([]);
//   };

//   const handleCalenderPage = () => {
//     navigate(`${ROUTES.AVAILABILITY}/slotCalander/view`); // Use a function reference here
//   };

//   // permission code for this module start
//   const [permissionAccess, setPermissionAccess] = useState();
//   const rawPermission = useSelector((state) => state?.permission?.value);
//   const permissions = decryptAEStoJSON(rawPermission);
//   useEffect(() => {
//     const RoleAccessFilterData =
//       permissions &&
//       permissions?.filter((v) => v?.moduleName === "Availability Management");
//     setPermissionAccess(RoleAccessFilterData?.[0]);
//   }, []);
//   // permission code for this module end

//   useEffect(() => {
//     if (location?.state?.reopenAvailabilityModal) {
//       addbuttonClick?.current.click();

//       // Reopen Check Availability modal with passed data
//       setShowUpdateSlot(true);

//       setSelectedSlotId(null);
//       setBtnDisabled(true);
//       setSelectedDate(new Date(location.state?.selectedDate || Date.now()));
//       setDoctorData(location.state?.doctorDetails);

//       // Clean the navigation state so modal doesn't reopen on refresh
//       navigate(location.pathname, { replace: true, state: {} });
//     }
//   }, [location]);

//   // get all experties in doctor
//   const [expertiesData, setExpertiesData] = useState([])
//   // const fetchAllExpertiesList = async () => {
//   //   try {
//   //     const response = await getExpertiesById(doctorData?.id, i18n.language);
//   //     if (response?.data?.status !== 200) {
//   //       // toastEmitter("error", response?.data?.message);
//   //       setExpertiesData([]);
//   //     }
//   //     // else {
//   //     //   setExpertiesData(response?.data?.data?.expertiseName);
//   //     // }
//   //     else {
//   //       const list = response?.data?.data?.expertiseName || [];
//   //       setExpertiesData(list);

//   //       // AUTO SELECT FIRST EXPERTISE
//   //       if (list.length > 0) {
//   //         setViewDoctorSlotPayload((prev) => ({
//   //           ...prev,
//   //           expertise: list[0].expertiseName,
//   //         }));
//   //       }
//   //     }
//   //   } catch (err) {
//   //     // toastEmitter("error", API_RESPONSE?.MESSAGE_503);
//   //   }
//   // };
// const fetchAllExpertiesList = async (doctorId) => {
//   if (!doctorId) return;

//   try {
//     const response = await getExpertiesById(doctorId, i18n.language);

//     if (response?.data?.status !== 200) {
//       setExpertiesData([]);
//     } else {
//       const list = response?.data?.data?.expertiseName || [];
//       setExpertiesData(list);

//       // auto select first
//       if (list.length > 0) {
//         setViewDoctorSlotPayload((prev) => ({
//           ...prev,
//           expertise: list[0].expertiseName,
//         }));
//       }
//     }
//   } catch {
//     setExpertiesData([]);
//   }
// };
// useEffect(() => {
//   if (!doctorData?.id) return;

//   fetchAllExpertiesList(doctorData.id);
// }, [doctorData?.id, i18n.language]);


//   // useEffect(() => {
//   //   if (doctorData?.id) {
//   //     fetchAllExpertiesList();
//   //   }
//   // }, [i18n.language, doctorData?.id]);
//   return (
//     <>
//       {permissionAccess?.addAction === 0 &&
//         permissionAccess?.updateAction === 0 &&
//         permissionAccess?.viewAction === 0 ? (
//         <>
//           <AccessPermissionpage />
//         </>
//       ) : (
//         <>
//           <div className="main_datatable my-lg-3 my-2">
//             <TableHeading
//               title={t("Availability Management")}
//               searchValue={searchTerm}
//               setSearchValue={setSearchTerm}
//               showNormalbutton={permissionAccess?.viewAction === 1}
//               ButtonClick={
//                 permissionAccess?.viewAction === 1
//                   ? handleCalenderPage
//                   : undefined
//               }
//               showbutton={false}
//               data="Show All Availability"
//             />

//             <div className="table-wrapper">
//               <TableLayout
//                 _tblColumns={tableColumns}
//                 _rowData={rowData}
//                 pending={pending}
//                 pagination={true}
//                 selectableRows={false}
//                 setPending={setPending}
//                 _totalRows={totalRows}
//                 pageSize={pageSize}
//                 setPageSize={setPageSize}
//                 setPage={setPage}
//                 setSortColumn={setSortColumn}
//                 setSortDirection={setSortDirection}
//               />
//             </div>
//           </div>
//           <Modal
//             modalId="availabilityView"
//             modalClick={addbuttonClick}
//             className="modal-lg"
//             // modalContentClass="pb-0"
//             modalfooter="mt-2"
//           >
//             {showUpdateSlot ? (
//               <div className="availabilityModel_content ">
//                 <div className="row ">
//                   <div className="col-12 col-lg-5  mb-2">
//                     <div className="dropdown-container mb-2">
//                       {/* <select
//                         className="form-select"
//                         name="expertise"
//                         value={viewDoctorSlotPayload?.expertise}
//                         onChange={(e) => setViewDoctorSlotPayload(handleFormInput(e, viewDoctorSlotPayload))}
//                       >
//                         <option value="" className="font-primary">
//                           Select Expertise
//                         </option>
//                         {expertiesData &&
//                           [...expertiesData]
//                             .sort((a, b) => a.expertiseName?.localeCompare(b.expertiseName))
//                             .map((item, index) => (
//                               <option key={index} value={item?.expertiseName}>
//                                 {item?.expertiseName}
//                               </option>
//                             ))}
//                       </select> */}
//                       <select
//                         className="form-select"
//                         name="expertise"
//                         value={viewDoctorSlotPayload?.expertise}
//                         onChange={(e) =>
//                           setViewDoctorSlotPayload(
//                             handleFormInput(e, viewDoctorSlotPayload)
//                           )
//                         }
//                       >
//                         {/* <option value="">Select Expertise</option> */}
//                         {expertiesData.map((item, index) => (
//                           <option key={index} value={item.expertiseName}>
//                             {item.expertiseName}
//                           </option>
//                         ))}
//                       </select>

//                     </div>
//                     <div className="addavailabiltymodel_left_content card border-0 h-100 mb-2" >
//                       <Calendar
//                         minDate={today}
//                         onChange={handleDateChange}
//                         locale={i18n.language}
//                         value={selectedDate}
//                       />
//                     </div>


//                   </div>
//                   <div className="col-12 col-lg-7 mb-2">
//                     <div className="addavailabiltymodel py-2 ">
//                       <div className="d-flex flex-wrap justify-content-between px-2 py-2">
//                         <h5>{t("Availability")}</h5>
//                         <Button
//                           label={t("Add Availability")}
//                           className={` border-0 text-white py-1 px-3 rounded-3 ${isBlock?.isBlockedByDay ? "cancelbtn" : "submitbtn"
//                             }`}
//                           onClick={addAvailabilityClick}
//                           isLoading={isBlock?.isBlockedByDay}
//                           notShowLoading={true}
//                         />
//                       </div>
//                       <hr className="mt-0 textcolor " />
//                       {isLoading ? (
//                         <LoaderSpinner />
//                       ) : (
//                         <div className="px-2">
//                           {(allAvailableSlot &&
//                             allAvailableSlot?.length !== 0) && (allAvailableSlot?.offlineSlots !== null || allAvailableSlot?.onlineSlots !== null) ? (
//                             <>
//                               {onlineSlot && onlineSlot?.length !== 0 && (
//                                 <div className="online_content mb-2  container p-2">
//                                   <div className="row addavailability_content">
//                                     <div className="col-12  d-flex justify-content-start align-items-center mb-2">
//                                       <p className="textcolor btn btn-outline-textcolor rounded online_content px-2 py-0 ">
//                                         {t("Online")}
//                                       </p>
//                                     </div>
//                                     {onlineSlotError && (
//                                       <p className="text-danger fs-12 text-start">
//                                         {onlineSlotError}
//                                       </p>
//                                     )}

//                                     <>
//                                       {onlineSlot &&
//                                         onlineSlot?.map((clinicSlot, idx) =>
//                                           clinicSlot?.timeSlots?.map((slot) => {
//                                             // Skip blocked slots
//                                             // if (slot?.isBlockedByTime)
//                                             //   return null;
//                                             const isSelected =
//                                               selectedSlotId === slot?.id;

//                                             return (
//                                               <div
//                                                 key={slot?.id}
//                                                 className={`col-12 col-lg-4 mb-2 cursor-pointer`}
//                                                 onClick={() => {
//                                                   if (slot?.isBooked) {
//                                                     toastEmitter(
//                                                       "error",
//                                                       "This slot is already booked and cannot be edited or deleted."
//                                                     );
//                                                     return;
//                                                   }
//                                                   handleSlotClick(
//                                                     slot?.id,
//                                                     slot?.startTime,
//                                                     slot?.endTime,
//                                                     "Online"
//                                                   );
//                                                 }}
//                                               >
//                                                 <p
//                                                   className={`rounded fs-12 mb-2 mb-md-0 py-2  fw-500 ${isSelected
//                                                     ? "text-white buttonColor"
//                                                     : slot?.isBooked
//                                                       ? "color-green-bold bg-green-normal" : slot?.isBlockedByTime ? "bg-light"
//                                                         : "buttonLightColor"
//                                                     }`}
//                                                 >
//                                                   {convertTimeToAmPm(
//                                                     slot?.startTime
//                                                   )}
//                                                   -
//                                                   {convertTimeToAmPm(
//                                                     slot?.endTime
//                                                   )}
//                                                 </p>
//                                               </div>
//                                             );
//                                           })
//                                         )}
//                                     </>
//                                   </div>
//                                   <div className="row ">
//                                     <div className="col-12 col-lg-4 pe-lg-0">
//                                       <div
//                                         className="text-align-center rounded  dangerColorLight mb-2 mb-md-0  p-1 cursor-pointer"
//                                         onClick={() =>
//                                           handleDeleteAvailability("Online")
//                                         }
//                                       >
//                                         <button
//                                           className="dangerColorLight rounded border-0 cursor-pointer "
//                                           disabled={btnDisabled}
//                                         >
//                                           {onlineDeleteLoading && (
//                                             <i className="fa fa-spinner fa-spin me-2"></i>
//                                           )}
//                                           <img
//                                             src={DELETE_ICON}
//                                             alt="delete"
//                                             classNam
//                                             e="img-fluid "
//                                           />
//                                         </button>
//                                       </div>
//                                     </div>

//                                     <div className="col-12 col-lg-8 cursor-pointer">
//                                       <button
//                                         className="textcolor rounded buutonlightPrimeryColor mb-2 mb-md-0  p-1 border-0 w-100 cursor-pointer"
//                                         onClick={handleUpdateCheck}
//                                       >
//                                         {t("Edit")}
//                                       </button>
//                                     </div>
//                                   </div>
//                                 </div>
//                               )}
//                               {offlineSlot && offlineSlot?.length !== 0 && (
//                                 <div className="ofline_content container p-2">
//                                   <div className="row addavailability_content">
//                                     <div className="col-12  d-flex justify-content-start align-items-center mb-2">
//                                       <p className="textcolor btn btn-outline-textcolor rounded online_content px-2 py-0 ">
//                                         {t("Offline")}
//                                       </p>
//                                     </div>
//                                     {offlineSlotError && (
//                                       <p className="text-danger fs-12 text-start">
//                                         {offlineSlotError}
//                                       </p>
//                                     )}
//                                     {offlineSlot &&
//                                       offlineSlot?.map((clinicSlot, idx) =>
//                                         clinicSlot?.timeSlots?.map((slot) => {
//                                           if (slot?.isBlockedByTime)
//                                             return null;
//                                           const isSelected =
//                                             selectedSlotId === slot?.id; // assuming slot.id exists

//                                           return (
//                                             <div
//                                               key={slot?.id}
//                                               className={`col-12 col-lg-4 mb-2 cursor-pointer`}
//                                               onClick={() => {
//                                                 if (slot?.isBooked) {
//                                                   toastEmitter(
//                                                     "error",
//                                                     "This slot is already booked and cannot be edited or deleted."
//                                                   );
//                                                   return;
//                                                 }

//                                                 handleSlotClick(
//                                                   slot?.id,
//                                                   slot?.startTime,
//                                                   slot?.endTime,
//                                                   "Offline"
//                                                 );
//                                               }}
//                                             >
//                                               <p
//                                                 className={`rounded fs-12 mb-2 mb-md-0 py-2 fw-500 ${isSelected
//                                                   ? " buttonColor text-white"
//                                                   : slot?.isBooked
//                                                     ? "color-green-bold bg-green-normal"
//                                                     : "buttonLightColor"
//                                                   }`}
//                                               >
//                                                 {convertTimeToAmPm(
//                                                   slot?.startTime
//                                                 )}
//                                                 -
//                                                 {convertTimeToAmPm(
//                                                   slot?.endTime
//                                                 )}
//                                               </p>
//                                             </div>
//                                           );
//                                         })
//                                       )}

//                                     <div className="col-12  d-flex justify-content-start mb-2">
//                                       <div>
//                                         {" "}
//                                         <img src={LOCATION_ICON} alt="Icon" />
//                                       </div>
//                                       <p>{userData?.address}</p>
//                                     </div>
//                                   </div>
//                                   <div className="row">
//                                     <div className="col-12 col-lg-4 pe-lg-0">
//                                       <div
//                                         className="text-align-center rounded  dangerColorLight mb-2 mb-md-0  p-1 cursor-pointer"
//                                         onClick={() =>
//                                           handleDeleteAvailability("Offline")
//                                         }
//                                       >
//                                         <button
//                                           className="dangerColorLight rounded border-0 cursor-pointer "
//                                           disabled={btnDisabled}
//                                         >
//                                           {offlineDeleteLoading && (
//                                             <i className="fa fa-spinner fa-spin me-2"></i>
//                                           )}
//                                           <img
//                                             src={DELETE_ICON}
//                                             alt="delete"
//                                             classNam
//                                             e="img-fluid "
//                                           />
//                                         </button>
//                                       </div>
//                                     </div>

//                                     <div className="col-12 col-lg-8 cursor-pointer">
//                                       <button
//                                         className="textcolor rounded buutonlightPrimeryColor mb-2 mb-md-0  p-1 border-0 w-100 cursor-pointer"
//                                         onClick={handleUpdateCheck}
//                                       >
//                                         Edit
//                                       </button>
//                                     </div>
//                                   </div>
//                                 </div>
//                               )}
//                             </>
//                           ) : (
//                             <div className="">
//                               <img
//                                 src={NOAVAILABILITYADDED}
//                                 alt="icon"
//                                 className="modelsuccessimg mb-2"
//                               />
//                               <h2 className="tableheading fs-18 mb-2 fw-500">
//                                 {t(
//                                   `${isBlock?.isBlockedByDay
//                                     ? "Availability block for full day !"
//                                     : t("Availability Not Added Yet !")
//                                   } `
//                                 )}
//                               </h2>
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <>
//                 <div className="availabilityModel_content ">
//                   <div className="row ">
//                     <div className="col-12 col-lg-5 mb-2">
//                       <div className="addavailabiltymodel_left_content card border-0 h-100 ">
//                         <Calendar
//                           minDate={today}
//                           onChange={handleDateChange}
//                           value={selectedDate}
//                         />
//                       </div>

//                     </div>
//                     <div className="col-12 col-lg-7 mb-2">
//                       <div className="addavailabiltymodel py-2 ">
//                         <div className="d-flex flex-wrap justify-content-between px-2 py-2">
//                           <h5>{t("Edit Availability")}</h5>
//                         </div>
//                         <hr className="mt-0 textcolor" />
//                         <div className="px-2">
//                           <div className="row">
//                             <div className="col-12  d-flex justify-content-start mb-2">
//                               <p className="textcolor btn btn-outline-textcolor rounded online_content px-2 py-0 ">
//                                 {t(typeOfSlot)}
//                               </p>
//                             </div>
//                             <div className="col-6">
//                               <TimePicker
//                                 value={
//                                   updateAvailabilityPayload?.fromTime
//                                     ? dayjs(
//                                       updateAvailabilityPayload?.fromTime,
//                                       "HH:mm"
//                                     )
//                                     : null
//                                 }
//                                 className={"form-control"}
//                                 format="HH:mm"
//                                 placeholder="From"
//                                 onChange={(time) => handleFrom(time || "")}
//                               />
//                             </div>
//                             <div className="col-6">
//                               <TimePicker
//                                 value={
//                                   updateAvailabilityPayload?.toTime
//                                     ? dayjs(
//                                       updateAvailabilityPayload?.toTime,
//                                       "HH:mm"
//                                     )
//                                     : null
//                                 }
//                                 className={"form-control"}
//                                 format="HH:mm"
//                                 placeholder="To"
//                                 onChange={(time) => handleTo(time || "")}
//                                 disabled={!updateAvailabilityPayload?.fromTime}
//                                 disabledTime={() => {
//                                   if (!updateAvailabilityPayload?.fromTime)
//                                     return {};
//                                   const fromTime = dayjs(
//                                     updateAvailabilityPayload?.fromTime,
//                                     "HH:mm"
//                                   );
//                                   return {
//                                     disabledHours: () => [
//                                       ...Array(fromTime?.hour()).keys(),
//                                     ],
//                                     disabledMinutes: (h) =>
//                                       h === fromTime.hour()
//                                         ? [
//                                           ...Array(
//                                             fromTime.minute() + 15
//                                           ).keys(),
//                                         ]
//                                         : [],
//                                   };
//                                 }}
//                               />
//                             </div>
//                             {typeOfSlot === "Offline" && (
//                               <div className="col-12">
//                                 <Input
//                                   className="border-radius_input py-2"
//                                   type="text"
//                                   value={userData?.address}
//                                   name="location"
//                                   disabled
//                                   lableClassName="text-start d-flex justify-content-start"
//                                   labelName="Location"
//                                 />
//                               </div>
//                             )}
//                             <div className="col-12  cursor-pointer mt-2">
//                               <div className="row">
//                                 <div className="col-4">
//                                   <button
//                                     type="button"
//                                     className="p-1 rounded border-0 cancelbtn me-2  mb-2 mb-md-0 w-100 "
//                                     onClick={handleDataBack}
//                                   >
//                                     {t("Cancel")}
//                                   </button>
//                                 </div>
//                                 <div className="col-8">
//                                   <button
//                                     className="textcolor rounded buutonlightPrimeryColor mb-2 mb-md-0  p-1 border-0 w-100 fs-14"
//                                     disabled={btnDisabled}
//                                     onClick={handleUpdateAvailability}
//                                     type="button"
//                                   >
//                                     {isUpdateLoading && (
//                                       <i className="fa fa-spinner fa-spin me-2"></i>
//                                     )}
//                                     {t("Update")}
//                                   </button>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </>
//             )}
//           </Modal>
//         </>
//       )}
//     </>
//   );
// };

// export default AvailabilityManagement;
